import React from "react";

type Props = {
  className?: string;
};
export const ChatIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.15317 17.9085L4.61031 18.2645L4.74083 17.7302L4.49511 17.2382L3.15317 17.9085ZM2.05528 22.4022L3.51242 22.7582L3.51242 22.7582L2.05528 22.4022ZM3.27147 23.6091L2.90432 22.1548L2.90432 22.1548L3.27147 23.6091ZM7.516 22.5376L8.2649 21.238L7.73822 20.9345L7.14885 21.0833L7.516 22.5376ZM22.5 13C22.5 18.2467 18.2467 22.5 13 22.5V25.5C19.9036 25.5 25.5 19.9036 25.5 13H22.5ZM13 3.5C18.2467 3.5 22.5 7.75329 22.5 13H25.5C25.5 6.09644 19.9036 0.5 13 0.5V3.5ZM3.5 13C3.5 7.75329 7.75329 3.5 13 3.5V0.5C6.09644 0.5 0.5 6.09644 0.5 13H3.5ZM4.49511 17.2382C3.85873 15.9641 3.5 14.5261 3.5 13H0.5C0.5 15.0018 0.971647 16.8977 1.81124 18.5787L4.49511 17.2382ZM3.51242 22.7582L4.61031 18.2645L1.69603 17.5525L0.598138 22.0462L3.51242 22.7582ZM2.90432 22.1548C3.26965 22.0625 3.60185 22.3922 3.51242 22.7582L0.598138 22.0462C0.151014 23.8763 1.81199 25.5246 3.63862 25.0635L2.90432 22.1548ZM7.14885 21.0833L2.90432 22.1548L3.63862 25.0635L7.88314 23.992L7.14885 21.0833ZM13 22.5C11.2728 22.5 9.65756 22.0404 8.2649 21.238L6.76709 23.8373C8.6031 24.8953 10.7332 25.5 13 25.5V22.5Z"
        fill="black"
      />
    </svg>
  );
};
